"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomTextField = _interopRequireDefault(require("./CustomTextField"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    },
    tblCell: {
      padding: '4px 6px 4px 6px'
    }
  };
};
var CustomTechnologyInstallation = /*#__PURE__*/function (_Component) {
  function CustomTechnologyInstallation(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomTechnologyInstallation);
    _this = _callSuper(this, CustomTechnologyInstallation, [props]);
    //Convert the string value into an array of arrays representing the rows
    var rows = props.value ? props.value.map(function (v, index) {
      var a = JSON.parse(v);
      var status = (0, _lodash.find)(props.answers, {
        value: a[0]
      });
      var vendor = (0, _lodash.find)(props.vendorsList, {
        value: a[1]
      });
      var product = (0, _lodash.find)(props.productsList, {
        value: a[2]
      });
      var contractDate = (0, _lodash.find)(props.contractDates, {
        value: a[3]
      });
      var contractDuration = (0, _lodash.find)(props.contractDurations, {
        value: a[4]
      });
      var installationID = a[5];
      var planToUpgrade = (0, _lodash.find)(props.standardYesNoOptions, {
        value: a[6]
      });
      var planUpgradeTimeframe = (0, _lodash.find)(props.planUpgradeTimeframeOptions, {
        value: a[7]
      });
      var upgradeVersion = a[8];
      var otherVendor = a[9];
      var otherProduct = a[10];
      var levelOfIntegration = (0, _lodash.find)(props.levelOfIntegration, {
        value: a[11]
      });
      return {
        id: index,
        status: status ? status : {
          value: undefined
        },
        vendor: vendor ? vendor : {
          value: undefined
        },
        product: product ? product : {
          value: undefined
        },
        contractDate: contractDate ? contractDate : {
          value: undefined
        },
        contractDuration: contractDuration ? contractDuration : '',
        installationID: installationID ? installationID : '',
        planToUpgrade: planToUpgrade ? planToUpgrade : {
          value: ''
        },
        planUpgradeTimeframe: planUpgradeTimeframe ? planUpgradeTimeframe : {
          value: ''
        },
        upgradeVersion: upgradeVersion ? upgradeVersion : '',
        otherVendor: otherVendor ? otherVendor : '',
        otherProduct: otherProduct ? otherProduct : '',
        levelOfIntegration: levelOfIntegration ? levelOfIntegration : {
          value: undefined
        }
      };
    }) : [];
    if (rows.length === 0) {
      rows.push({
        id: rows.length,
        status: {
          value: undefined
        },
        vendor: {
          value: undefined
        },
        product: {
          value: undefined
        },
        contractDate: {
          value: undefined
        },
        contractDuration: '',
        installationID: '',
        planToUpgrade: {
          value: ''
        },
        planUpgradeTimeframe: {
          value: ''
        },
        upgradeVersion: '',
        otherVendor: '',
        otherProduct: '',
        levelOfIntegration: {
          value: undefined
        }
      });
    }
    _this.state = {
      rows: rows
    };
    ['addRow', 'updateRow', 'deleteRow', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomTechnologyInstallation, _Component);
  return (0, _createClass2["default"])(CustomTechnologyInstallation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        vendorsList = _this$props.vendorsList,
        productsList = _this$props.productsList,
        countryID = _this$props.countryID,
        technologyId = _this$props.technologyId,
        language = _this$props.language,
        resources = _this$props.resources;
      console.log('CountryID componentWillMount', countryID);
      var filteredVendorsList = (0, _lodash.filter)(vendorsList, function (v) {
        var matchesTech = v.technologies.length === 0 || v.technologies.includes(technologyId);
        var matchesCountry = !countryID || v.countries.length === 0 || v.countries.includes(Number(countryID));
        return matchesTech && matchesCountry;
      });

      //Filter the list of products based on the current tab technologyId and the countryID of the entity.
      var filteredProductsList = (0, _lodash.filter)(productsList, function (p) {
        var matchesTech = p.technologies.length === 0 || p.technologies.includes(_this2.props.technologyId);
        var matchesCountry = !countryID || p.countries.length === 0 || p.countries.includes(Number(countryID));
        return matchesTech && matchesCountry;
      });
      filteredVendorsList = (0, _lodash.sortBy)(filteredVendorsList, ['label']);
      filteredProductsList = (0, _lodash.sortBy)(filteredProductsList, ['label']);
      this.setState({
        filteredVendorsList: filteredVendorsList,
        filteredProductsList: filteredProductsList
      });
    }
  }, {
    key: "addRow",
    value: function addRow() {
      var rows = [].concat(this.state.rows);
      rows.push({
        id: rows.length,
        status: {
          value: undefined
        },
        vendor: {
          value: undefined
        },
        product: {
          value: undefined
        },
        contractDate: {
          value: undefined
        },
        contractDuration: '',
        installationID: '',
        planToUpgrade: {
          value: ''
        },
        planUpgradeTimeframe: {
          value: ''
        },
        upgradeVersion: '',
        otherVendor: '',
        otherProduct: '',
        levelOfIntegration: {
          value: undefined
        }
      });
      this.setState({
        rows: rows
      });
      this.props.onChange(this.convertToValue(rows));
    }
  }, {
    key: "addSpecialRow",
    value: function addSpecialRow() {
      var rows = [].concat(this.state.rows);
      rows.push({
        id: rows.length,
        status: {
          value: undefined
        },
        vendor: {
          value: undefined
        },
        product: {
          value: undefined
        },
        contractDate: {
          value: undefined
        },
        contractDuration: '',
        installationID: '',
        planToUpgrade: {
          value: ''
        },
        planUpgradeTimeframe: {
          value: ''
        },
        upgradeVersion: '',
        otherVendor: '',
        otherProduct: '',
        levelOfIntegration: {
          value: undefined
        },
        tag: 'special row'
      });
      this.setState({
        rows: rows
      });
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(id) {
      var rows = [].concat(this.state.rows);
      var idx = rows.findIndex(function (r) {
        return r.id === id;
      });
      rows.splice(idx, 1);
      this.setState({
        rows: rows
      });

      //Convert the rows array into a string value that can be saved off to the survey
      this.props.onChange(this.convertToValue(rows));
    }
  }, {
    key: "updateRadio",
    value: function updateRadio(id, field) {
      var _this3 = this;
      return function (value) {
        var rows = [].concat(_this3.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = {
          value: value.target.value
        };
        if (field === 'planToUpgrade' && value && value.value !== '298') {
          rows[idx]['planUpgradeTimeframe'] = {
            value: ''
          };
          rows[idx]['upgradeVersion'] = '';
        }
        _this3.setState({
          rows: rows
        });

        //Convert the rows array into a string value that can be saved off to the survey
        _this3.props.onChange(_this3.convertToValue(rows));
      };
    }
  }, {
    key: "updateText",
    value: function updateText(id, field) {
      var _this4 = this;
      return function (value) {
        var rows = [].concat(_this4.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = value.target.value;
        _this4.setState({
          rows: rows
        });

        //Convert the rows array into a string value that can be saved off to the survey
        _this4.props.onChange(_this4.convertToValue(rows));
      };
    }
  }, {
    key: "updateRow",
    value: function updateRow(id, field) {
      var _this5 = this;
      return function (event, value) {
        var rows = [].concat(_this5.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = !value ? {
          value: undefined
        } : value;
        //If that status changes to Not Automated or Service not provided clear out the contract date and duration
        if (field === 'status' && (!value || value === '' || value.value === '' || value && (value.value === '191' || value.value === '248'))) {
          /* Not Automated and Service Not Provided */
          rows[idx]['vendor'] = {
            value: undefined
          };
          rows[idx]['product'] = {
            value: undefined
          };
          rows[idx]['contractDate'] = {
            value: undefined
          };
          rows[idx]['contractDuration'] = '';
          rows[idx]['planToUpgrade'] = {
            value: ''
          };
          rows[idx]['planUpgradeTimeframe'] = {
            value: ''
          };
          rows[idx]['upgradeVersion'] = '';
        }
        if (field === 'status' && (!value || value === '' || value.value === '' || value.value !== '165')) {
          rows[idx]['levelOfIntegration'] = {
            value: undefined
          };
        }

        //If the vendor changes reset the product
        if (field === 'vendor') {
          rows[idx]['product'] = {
            value: undefined
          };
        }
        _this5.setState({
          rows: rows
        });

        //Convert the rows array into a string value that can be saved off to the survey
        _this5.props.onChange(_this5.convertToValue(rows));
        if (field == 'status' && value && value.value == '265') {
          _this5.addSpecialRow();
        }
      };
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(rows) {
      //Convert to array or arrays for simplicity when saving the surey values
      var value = rows.map(function (r) {
        var _r$status, _r$vendor, _r$product, _r$contractDate, _r$contractDuration, _r$planToUpgrade, _r$planUpgradeTimefra, _r$levelOfIntegration;
        return JSON.stringify([(_r$status = r.status) === null || _r$status === void 0 ? void 0 : _r$status.value, (_r$vendor = r.vendor) === null || _r$vendor === void 0 ? void 0 : _r$vendor.value, (_r$product = r.product) === null || _r$product === void 0 ? void 0 : _r$product.value, (_r$contractDate = r.contractDate) === null || _r$contractDate === void 0 ? void 0 : _r$contractDate.value, (_r$contractDuration = r.contractDuration) === null || _r$contractDuration === void 0 ? void 0 : _r$contractDuration.value, r.installationID, (_r$planToUpgrade = r.planToUpgrade) === null || _r$planToUpgrade === void 0 ? void 0 : _r$planToUpgrade.value, (_r$planUpgradeTimefra = r.planUpgradeTimeframe) === null || _r$planUpgradeTimefra === void 0 ? void 0 : _r$planUpgradeTimefra.value, r.upgradeVersion, r.otherVendor, r.otherProduct, (_r$levelOfIntegration = r.levelOfIntegration) === null || _r$levelOfIntegration === void 0 ? void 0 : _r$levelOfIntegration.value]);
      });
      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes,
        distinctProducts = _this$props2.distinctProducts,
        levelOfIntegration = _this$props2.levelOfIntegration,
        resources = _this$props2.resources,
        language = _this$props2.language;
      var _this$state = this.state,
        filteredProductsList = _this$state.filteredProductsList,
        filteredVendorsList = _this$state.filteredVendorsList;
      var rows = this.state.rows;
      var disabled = rows.length == 1;
      var minID = rows.reduce(function (min, r) {
        return r.id < min ? r.id : min;
      }, rows[0].id);
      var blankOption = [{
        label: '',
        value: ''
      }];
      var specialRow = false;
      var showLevelOfIntegration = levelOfIntegration !== null;
      return rows.map(function (r) {
        var vendorProductsList = r.vendor && r.vendor.value !== '' ? (0, _lodash.filter)(filteredProductsList, function (p) {
          return p.vendorID === r.vendor.value;
        }) : distinctProducts;
        if (r.tag) {
          specialRow = true;
        }
        var specialStatus = [{
          label: 'Contracted/Not Yet Installed',
          value: '79'
        }, {
          label: ' Installation in Process',
          value: '150'
        }];
        return /*#__PURE__*/_react["default"].createElement(_material.Table, {
          key: 'table_' + r.id
        }, showLevelOfIntegration && /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '20%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '10%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '20%'
          }
        })), !showLevelOfIntegration && /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        }), /*#__PURE__*/_react["default"].createElement("col", {
          style: {
            width: '25%'
          }
        })), /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          style: {
            backgroundColor: '#fafafa'
          }
        }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Status')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Vendor')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Product')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Contract Year')), showLevelOfIntegration && /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.centerText
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Level of Integration with EMR/CDR')), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, r.id === minID ? /*#__PURE__*/_react["default"].createElement(_material.Button, {
          disabled: rows.find(function (row) {
            return row.status === '' || row.status.value === '' || row.status.value === '191' || row.status.value === '248';
          }) ? true : false,
          variant: "contained",
          color: "primary",
          className: classes.button,
          onClick: function onClick() {
            return _this6.addRow();
          }
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Add')) : ''))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, specialRow && /*#__PURE__*/_react["default"].createElement(_material.TableRow, null, "Please tell us about the vendor and product purchased that will replace this installation"), /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          key: r.id
        }, specialRow && /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "status",
          value: r.status,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'status', value);
          },
          options: specialStatus,
          isMulti: false,
          disabled: false,
          label: ""
        })), !specialRow && /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "status",
          value: r.status,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'status', value);
          },
          options: blankOption.concat(_this6.props.answers),
          isMulti: false,
          disabled: false,
          label: ""
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "vendor",
          value: r.vendor,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'vendor', value);
          },
          options: blankOption.concat(filteredVendorsList),
          isMulti: false,
          disabled: !r.status || r.status.value === '191' || r.status.value === '248' /* Not Automated and Service Not Provided */,
          label: ""
        }), r.vendor && r.vendor.value == '5791' && /*#__PURE__*/_react["default"].createElement(_CustomTextField["default"], {
          className: classes.textField,
          key: "otherVendor",
          margin: "dense",
          name: "othervendor",
          defaultValue: r.otherVendor,
          onBlur: _this6.updateText(r.id, 'otherVendor')
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "product",
          value: r.product,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'product', value);
          },
          options: blankOption.concat(vendorProductsList),
          isMulti: false,
          disabled: r.status.value === '191' || r.status.value === '248' /* Not Automated and Service Not Provided */,
          label: ""
        }), r.product.value == '6294' && /*#__PURE__*/_react["default"].createElement(_CustomTextField["default"], {
          className: classes.textField,
          key: "otherProduct",
          margin: "dense",
          name: "otherproduct",
          defaultValue: r.otherProduct,
          onBlur: _this6.updateText(r.id, 'otherProduct')
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "contractDate",
          value: r.contractDate,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'contractDate', value);
          },
          options: blankOption.concat(_this6.props.contractDates),
          isMulti: false,
          disabled: r.status.value === '191' || r.status.value === '248' /* Not Automated and Service Not Provided */,
          label: ""
        })), showLevelOfIntegration && /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "levelOfIntegration",
          value: r.levelOfIntegration,
          onChange: function onChange(value) {
            return _this6.updateRow(r.id, 'levelOfIntegration', value);
          },
          options: blankOption.concat(_this6.props.levelOfIntegration),
          isMulti: false,
          disabled: r.status.value !== '165',
          label: ""
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
          className: classes.tblCell
        }, !disabled && /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          className: classes.button,
          onClick: function onClick() {
            return _this6.deleteRow(r.id);
          }
        }, (0, _getResource.getResource)(resources, language, 'Label', 'Delete'))))));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var vendorsList = props.vendorsList,
        productsList = props.productsList,
        countryID = props.countryID,
        technologyId = props.technologyId,
        resources = props.resources,
        language = props.language,
        value = props.value;
      var rows = props.value //["1", "2"]
      ? props.value.map(function (v, index) {
        var a = JSON.parse(v);
        var status = (0, _lodash.find)(props.answers, {
          value: a[0]
        });
        var vendor = (0, _lodash.find)(state.filteredVendorsList, {
          value: a[1]
        });
        var product = (0, _lodash.find)(state.filteredProductsList, {
          value: a[2]
        });
        var contractDate = (0, _lodash.find)(props.contractDates, {
          value: a[3]
        });
        var contractDuration = (0, _lodash.find)(props.contractDurations, {
          value: a[4]
        });
        var installationID = a[5];
        var planToUpgrade = (0, _lodash.find)(props.standardYesNoOptions, {
          value: a[6]
        });
        var planUpgradeTimeframe = (0, _lodash.find)(props.planUpgradeTimeframeOptions, {
          value: a[7]
        });
        var upgradeVersion = a[8];
        var otherVendor = a[9];
        var otherProduct = a[10];
        var levelOfIntegration = (0, _lodash.find)(props.levelOfIntegration, {
          value: a[11]
        });
        return {
          id: index,
          status: status ? status : {
            value: undefined
          },
          vendor: vendor ? vendor : {
            value: undefined
          },
          product: product ? product : {
            value: undefined
          },
          contractDate: contractDate ? contractDate : {
            value: undefined
          },
          contractDuration: contractDuration ? contractDuration : '',
          installationID: installationID ? installationID : '',
          planToUpgrade: planToUpgrade ? planToUpgrade : {
            value: ''
          },
          planUpgradeTimeframe: planUpgradeTimeframe ? planUpgradeTimeframe : {
            value: ''
          },
          upgradeVersion: upgradeVersion ? upgradeVersion : '',
          otherVendor: otherVendor ? otherVendor : '',
          otherProduct: otherProduct ? otherProduct : '',
          levelOfIntegration: levelOfIntegration ? levelOfIntegration : {
            value: undefined
          }
        };
      }) : [];
      if (rows.length === 0) {
        rows.push({
          id: rows.length,
          status: {
            value: undefined
          },
          vendor: {
            value: undefined
          },
          product: {
            value: undefined
          },
          contractDate: {
            value: undefined
          },
          contractDuration: '',
          installationID: '',
          planToUpgrade: {
            value: ''
          },
          planUpgradeTimeframe: {
            value: ''
          },
          upgradeVersion: '',
          otherVendor: '',
          otherProduct: '',
          levelOfIntegration: {
            value: undefined
          }
        });
      }
      var filteredVendorsList = (0, _lodash.filter)(vendorsList, function (v) {
        var matchesTech = v.technologies.length === 0 || v.technologies.includes(technologyId);
        var matchesCountry = !countryID || v.countries.length === 0 || v.countries.includes(Number(countryID));
        return matchesTech && matchesCountry;
      });

      //Filter the list of products based on the current tab technologyId and the countryID of the entity.
      var filteredProductsList = (0, _lodash.filter)(productsList, function (p) {
        var matchesTech = p.technologies.length === 0 || p.technologies.includes(technologyId);
        var matchesCountry = !countryID || p.countries.length === 0 || p.countries.includes(Number(countryID));
        return matchesTech && matchesCountry;
      });
      var translatedOther = (0, _getResource.getResource)(resources, language, 'Label', 'other').toLowerCase();
      var translatedSelfDeveloped = (0, _getResource.getResource)(resources, language, 'Label', 'self-developed').toLowerCase();
      state['filteredVendorsList'] = (0, _lodash.sortBy)(filteredVendorsList, [function (i) {
        return i.label.toLowerCase() === translatedOther ? '11111' : i.label.toLowerCase() === translatedSelfDeveloped ? '11112' : i.label;
      }]);
      state['filteredProductsList'] = (0, _lodash.sortBy)(filteredProductsList, [function (i) {
        return i.label.toLowerCase() === translatedOther ? '11111' : i.label.toLowerCase() === translatedSelfDeveloped ? '11112' : i.label;
      }]);
      state['rows'] = rows;
      return state;
    }
  }]);
}(_react.Component);
CustomTechnologyInstallation.propTypes = {
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired,
  previousValue: _propTypes["default"].string,
  vendorsList: _propTypes["default"].array.isRequired,
  productsList: _propTypes["default"].array.isRequired,
  technologyId: _propTypes["default"].number.isRequired,
  countryID: _propTypes["default"].number,
  entity: _propTypes["default"].object,
  answers: _propTypes["default"].array.isRequired,
  contractDates: _propTypes["default"].array.isRequired,
  contractDurations: _propTypes["default"].array.isRequired,
  standardYesNoOptions: _propTypes["default"].array.isRequired,
  planUpgradeTimeframeOptions: _propTypes["default"].array.isRequired,
  //levelOfIntegration: PropTypes.array.isRequired,
  distinctProducts: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomTechnologyInstallation);